function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0155 9.724C17.2539 10.4872 16.283 11.0075 15.2257 11.219C14.1684 11.4304 13.0721 11.3236 12.0755 10.912L5.58348 18.736C4.39548 19.924 2.47548 19.924 1.28748 18.736C0.0994844 17.548 0.0994844 15.628 1.28748 14.452L9.11149 7.948C8.29549 5.968 8.69148 3.616 10.2995 2.008C11.8355 0.471997 14.0435 0.0639975 15.9635 0.735997L12.4955 4.204L15.8795 7.588L19.3115 4.144C19.9475 6.04 19.5275 8.212 18.0155 9.724ZM2.57148 17.452C3.05148 17.92 3.81948 17.92 4.28748 17.452C4.76748 16.972 4.76748 16.204 4.28748 15.736C3.81948 15.256 3.05148 15.256 2.57148 15.736C2.34649 15.9649 2.22042 16.273 2.22042 16.594C2.22042 16.915 2.34649 17.2231 2.57148 17.452Z",
  fill: "#0080CB"
});

var SvgSetting = function SvgSetting(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSetting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/setting.c2367b15.svg";
export { ForwardRef as ReactComponent };